// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetMembershipOpenInvoicesRequestModel from '../../model/get-membership-open-invoices-request-model';
import GetMembershipOpenInvoicesRequestDTO from '../dto/get-membership-open-invoices-request-dto';
import dtoSchema from '../schemas/get-membership-open-invoices-request-schema';

export default abstract class GetMembershipOpenInvoicesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetMembershipOpenInvoicesRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetMembershipOpenInvoicesRequestDTO>): GetMembershipOpenInvoicesRequestModel;
  static toModel(dto: DeepPartial<GetMembershipOpenInvoicesRequestDTO> | undefined | null): GetMembershipOpenInvoicesRequestModel | undefined;
  static toModel(dto: DeepPartial<GetMembershipOpenInvoicesRequestDTO> | undefined | null): GetMembershipOpenInvoicesRequestModel | undefined {
    return dto ? new GetMembershipOpenInvoicesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetMembershipOpenInvoicesRequestModel> | GetMembershipOpenInvoicesRequestModel): GetMembershipOpenInvoicesRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetMembershipOpenInvoicesRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetMembershipOpenInvoicesRequestModel, can not map to GetMembershipOpenInvoicesRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
